import React, { useEffect } from 'react';
import {
  getBrandCurrencyOptions,
  getBrandDefaultCurrency,
  isBrandCurrencyLocked,
  SAUDI_CURRENCY_LABEL,
} from '../utils/brandCurrency';

/**
 * Currency selector — locked to SAR (ريال سعودي) on Qawaem / Saudi brand.
 */
export default function BrandCurrencySelect({
  value,
  onChange,
  className = 'w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500',
  disabled = false,
  id,
  name,
}) {
  const locked = isBrandCurrencyLocked();
  const options = getBrandCurrencyOptions();
  const resolved = locked ? getBrandDefaultCurrency() : (value || getBrandDefaultCurrency());

  useEffect(() => {
    if (locked && value !== getBrandDefaultCurrency()) {
      onChange?.({ target: { value: getBrandDefaultCurrency(), name } });
    }
  }, [locked, value, onChange, name]);

  if (locked) {
    return (
      <input
        id={id}
        name={name}
        type="text"
        readOnly
        disabled={disabled}
        value={SAUDI_CURRENCY_LABEL}
        className={`${className} cursor-default opacity-90`}
        aria-label={SAUDI_CURRENCY_LABEL}
      />
    );
  }

  return (
    <select
      id={id}
      name={name}
      value={resolved}
      disabled={disabled}
      onChange={onChange}
      className={className}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
